/* eslint-disable eqeqeq */
/* eslint-disable no-throw-literal */
import axios from "axios";
import qs from "qs";
//import { getToken, clearToken } from '../helpers/utility';
import {
  FORBIDDEN,
  INTERNAL_SERVER_ERROR,
  NOT_FOUND,
  UNAUTHORIZED,
} from "../constants/statusCode";
import {
  INTERNAL_ERROR,
  NOT_FOUND_MESSAGE,
  SERVER_ERROR,
  UNAUTHORIZED_MESSAGE,
} from "../constants/textConstants";
import { decrypt } from "../utils/encryption";

var internals = {};

internals.requestServer = function ({
  endPoint,
  data,
  method,
  headers,
  contentType,
  auth,
}) {
  let defaultHeaders = {
    Accept: "application/json",
    "Content-Type": contentType || "application/json",
  };
  switch (auth) {
    case "csrf":
      defaultHeaders["csrf-token"] = decrypt(
        localStorage.getItem("csrf-token")
      );
      localStorage.removeItem("csrf-token");
      break;
    case "token":
      defaultHeaders["Authorization"] = decrypt(
        localStorage.getItem("session-token")
      );
      break;


    case "system":
      defaultHeaders["Authorization"] = `Bearer ${process.env.REACT_API_TOKEN}`;
      break;
  }

  var params = {
    method: method || "GET",
    headers: Object.assign(headers || {}, defaultHeaders),
  };

  if (data) {
    if (params.method === "GET") {
      endPoint += (endPoint.indexOf("?") > -1 ? "&" : "?") + qs.stringify(data);
    } else {
      params.data = data;
    }
  }

  //REACT_APP_SERVER_URL is the Server URL for API calls
  params.url = `${process.env.REACT_APP_SERVER_URL}/mw/${endPoint}`;

  return axios(params, { crossDomain: true })
    .then(function (response) {
      return response.data;
    })
    .then(function (response) {
      return response;
    })

    .catch(function (error) {
      if (!error.response) {
        throw SERVER_ERROR;
      }
      switch (error.response.status) {
        case FORBIDDEN:
          throw UNAUTHORIZED_MESSAGE;
        case UNAUTHORIZED:
          throw UNAUTHORIZED_MESSAGE;
        case NOT_FOUND:
          throw NOT_FOUND_MESSAGE;
        case INTERNAL_SERVER_ERROR:
          throw INTERNAL_ERROR;
        default:
          if (error.response.data) {
            throw error.response.data.message;
          } else throw SERVER_ERROR;
      }
    });
};

export default internals.requestServer;
